import React from 'react'
import { ReactCookieProps } from 'react-cookie'
import { getStore } from '@utils/storeValues'

export interface UserSession {
  country: string
  language: string
  store: string
  accessToken: string
  profileToken?: string
  guid?: string
}

export const userSession = (
  cookies: ReactCookieProps['allCookies']
): UserSession => {
  return {
    country: (cookies && cookies.country) || '',
    accessToken: cookies && cookies.accessToken,
    profileToken: cookies && cookies.profileToken,
    guid: cookies && cookies.guid,
    language: (cookies && cookies.language) || '',
    // Logged-out users default to 'sial' or 'mm', users who use the B2bLogin will be 'b2b'
    store: (cookies && cookies.store) || getStore(),
  }
}

export const MobileContext = React.createContext<boolean>(false)
